import React, { useEffect, useMemo, useState } from "react";
import { NewSelectField } from "../FormItems/FormItems";
import { Button } from "../Button/Button";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";
import jobcardimg from "../../assets/image/jobcardimg.jpg";
import { CiLocationOn } from "react-icons/ci";
import { SlCalender } from "react-icons/sl";
import { MdOutlineWatchLater } from "react-icons/md";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { baseUrl } from "../../utils/base_url";
import { Pagination } from "antd";

const CareerJobs = ({
  jobs,
  natures,
  departments,
  cities,
  setCurrentPage,

  defaultCurrent,
  pageSize,
  total,
}) => {
  console.log(defaultCurrent, pageSize, total);

  const handlePages = (current, pageSize) => {
    setCurrentPage(current);
    console.log(current, pageSize);
  };

  const [selectedCityId, setSelectedCityId] = useState("");
  const [selectedDepartmentId, setSelectedDepartmentId] = useState("");
  const [selectedNatureId, setSelectedNatureId] = useState("");
  const [filteredJobs, setFilteredJobs] = useState(jobs);

  console.log(filteredJobs);

  const dropDownObj = [
    {
      label: "Department",
      required: true,
      options: departments,
      value: selectedDepartmentId,
      setter: setSelectedDepartmentId,
      default:"Department*",
    },
    {
      label: "City",
      required: true,
      options: cities,
      value: selectedCityId,
      // onChange={(e) => setSelectedCityId(e.target.value)}
      setter: setSelectedCityId,
      default:"City*",
    },
    {
      label: "Job Nature",
      required: true,
      options: natures,
      value: selectedNatureId,
      setter: setSelectedNatureId,
      default:"Job Nature*",
    },
  ];
  // const paginationValue = [
  //   {
  //     value: 1,
  //   },
  //   {
  //     value: 2,
  //   },
  //   {
  //     value: 3,
  //   },
  //   {
  //     value: 4,
  //   },
  // ];
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  useEffect(() => {
    const result = jobs.filter((job) => {
      const matchCity = selectedCityId
        ? job.job_city?.slug === selectedCityId
        : true;

      const matchDepartment = selectedDepartmentId
        ? job.job_department?.slug === selectedDepartmentId
        : true;

      const matchNature = selectedNatureId
        ? job.job_nature?.slug === selectedNatureId
        : true;

      return matchCity && matchDepartment && matchNature;
    });

    setFilteredJobs(result);
  }, [selectedCityId, selectedDepartmentId, selectedNatureId, jobs]);

  // useEffect(() => {
  //   const result = jobs.filter((job) => {
  //     console.log(job);
  //     const matchCity = selectedCityId
  //       ? job.job_city?.slug === selectedCityId
  //       : false;
  //     const matchDepartment = selectedDepartmentId
  //       ? job.job_department?.slug === selectedDepartmentId
  //       : false;
  //     const matchNature = selectedNatureId
  //       ? job.job_nature?.slug === selectedNatureId
  //       : false;
  //     console.log(
  //       matchCity,
  //       matchDepartment,
  //       matchNature,
  //       selectedCityId,
  //       selectedDepartmentId,
  //       selectedNatureId
  //     );
  //     if (
  //       !matchCity &&
  //       !matchDepartment &&
  //       !matchNature &&
  //       !selectedCityId &&
  //       !selectedDepartmentId &&
  //       !selectedNatureId
  //     ) {
  //       return true;
  //     }
  //     return matchCity || matchDepartment || matchNature;
  //   });

  //   setFilteredJobs(result);
  // }, [selectedCityId, selectedDepartmentId, selectedNatureId, jobs]);

  // const handleSelectChange = (name, id) => {
  //   // console.log(name, id)
  //   // const temp = [...selectedFilters];
  //   // const obj = {
  //   //   [name]: Number(id),
  //   // }
  //   // temp.push(obj)

  //   // console.log(temp);
  //   // setSelectedFilters(temp);
  // };

  return (
    <>
      <div
        className="container contwidth px-0 "
        style={{ paddingTop: "10rem" }}
      >
        <p
          className="text-white text-center fw700 p-0"
          style={{
            fontSize: _576
              ? "25px"
              : _768
              ? "37px"
              : _992
              ? "47px"
              : _1200
              ? "55px"
              : _1400
              ? "65px"
              : _1600
              ? "75px"
              : _1700
              ? "75px"
              : _1800
              ? "85px"
              : "90px",
          }}
        >
          You are the future world needs
        </p>

        <p
          className="text-white text-center fw700 pt-0 pb-3"
          style={{
            fontSize: _576
              ? "16px"
              : _768
              ? "18px"
              : _992
              ? "24px"
              : _1200
              ? "24px"
              : _1400
              ? "26px"
              : _1600
              ? "30px"
              : _1700
              ? "35px"
              : _1800
              ? "40px"
              : "40px",
          }}
        >
          Search our latest opportunities
        </p>

        <div className="row pt-5">
          {dropDownObj.map((data, index) => {
            return (
              <>
                <NewSelectField
                  placeholder={data?.default}
                  // label={data?.label}
                  required={data?.required}
                  labelClassName={"fs24 fw400"}
                  className={`col-12 col-md-3 ${
                    index === 0
                      ? "me-auto"
                      : index === 1
                      ? "mx-auto"
                      : index === 2
                      ? "ms-auto"
                      : ""
                  }`}
                  onChange={(e) => {
                    console.log(e);
                    data?.setter(e);
                  }}
                  value={data?.value}
                  selectClassName={"new-form-select"}
                  search={false}
                  option={data?.options?.map((item) => ({
                    value: item.slug,
                    label: item.name,
                  }))}
                  // onclick={(e) => handleSelectChange(e.label, e.value)}
                />
                ;
              </>
            );
          })}
        </div>

        <div style={{ paddingBottom: "4rem" }}>
          {filteredJobs?.map((item, index) => {
            return (
              <JobCard
                key={index}
                imgsrc={item?.image?.url}
                jobtitle={item?.heading}
                jobDescription={item?.excerpt}
                date={item?.createdAt?.split("T")[0]}
                time={item?.jobType}
                location={item?.job_city?.name}
                btnText={item?.CTA?.text}
              />
            );
          })}
          <div className="custom-pagination d-flex justify-content-center">
            <Pagination
              defaultCurrent={defaultCurrent}
              pageSize={pageSize}
              total={total}
              onChange={handlePages}
            />
          </div>
        </div>

        {/* <Pagination defaultCurrent={defaultCurrent} pageSize={pageSize} total={total} onChange={handlePages} /> */}
        {/* <div style={{ paddingBottom: "4rem" }}>
          {
              jobs.slice(0, 5)
              .map((item, index) => (
                <JobCard
                  key={item.id || index}
                  imgsrc={item?.image?.url}
                  jobtitle={item?.heading}
                  jobDescription={item?.excerpt}
                  date={item?.createdAt?.split("T")[0]}
                  time={item?.jobType}
                  location={item?.job_city?.name}
                  btnText={item?.CTA?.text}
                />
              ))}
        </div> */}

        {/* <div className="d-flex justify-content-center align-items-center gap-3 pb-5">
          <div>
            <FaAngleLeft size={28} color="white" />
          </div>
          {paginationValue.map((item) => {
            return (
              <>
                <div
                  className=" fw-bold rounded-circle d-flex justify-content-center align-items-center"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#E1E4F5",
                  }}
                >
                  {item?.value}
                </div>
              </>
            );
          })}
          <div>
            <FaAngleRight size={28} color="white" />
          </div>
        </div> */}
      </div>
    </>
  );
};

export default CareerJobs;

const JobCard = ({
  imgsrc,
  jobtitle,
  jobDescription,
  date,
  time,
  location,
  btnText,
}) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div
        className={`container bg-white my-5 rounded-5 px-4 contwidth ${
          _1600 ? "py-3" : ""
        }`}
      >
        <div
          className="d-flex flex-column flex-xl-row justify-content-between align-items-center "
          style={{ height: _1600 ? "max-content" : "211px" }}
        >
          <div className="d-flex flex-column flex-lg-row gap-4 ">
            <div
              className="align-self-center"
              style={{
                width: _1500 ? "150px" : "165px",
                height: _1500 ? "160px" : "171px",
              }}
            >
              <img
                className="rounded-5"
                style={{
                  width: _1500 ? "150px" : "165px",
                  height: _1500 ? "160px" : "171px",
                }}
                // src={jobcardimg}
                src={`${baseUrl}${imgsrc}`}
              />
            </div>

            <div>
              <p className="fs30 fw700 text" style={{ color: " #283950" }}>
                {/* Job Title */}
                {jobtitle}
              </p>
              <CardIcon
                // location={"New York, USA"}
                // date={"20.12.24"}
                // time={"Full Time"}
                date={date}
                time={time}
                location={location}
              />
              <p
                className=" fw400 text me-lg-5 lh-sm"
                style={{
                  fontSize: _576
                    ? "15px"
                    : _768
                    ? "22px"
                    : _992
                    ? "24px"
                    : _1200
                    ? "15px"
                    : _1400
                    ? "20px"
                    : _1500
                    ? "20px"
                    : _1600
                    ? "20px"
                    : _1700
                    ? "22px"
                    : _1800
                    ? "22px"
                    : "25px",
                  color: " #6B7890",
                }}
              >
                {/* Some description text about the job.text about the job.text
                about the job. */}
                {jobDescription}
              </p>
            </div>
          </div>
          <div className="px-5">
            <Button
              textColor={"white"}
              background={" #0039EC"}
              newButtonClassName={`${
                _1200
                  ? "fs16"
                  : _1400
                  ? "fs18"
                  : _1700
                  ? "fs20"
                  : _1800
                  ? "fs20"
                  : "fs20"
              } border-0 rounded-pill py-2 py-md-2 px-5`}
              width={"200px"}
              height={"51px"}
              //   onClick={() => navigate(data?.url)}
            >
              {/* {"LearnMore"} */}
              {btnText}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

const CardIcon = ({ location, date, time }) => {
  return (
    <>
      <div className="d-flex flex-wrap gap-3 justify-content-start align-items-start">
        <div className="d-flex gap-2 align-items-start">
          <div>
            {" "}
            <CiLocationOn size={24} style={{ color: " #1F46BE" }} />{" "}
          </div>
          <p style={{ color: " #1B1B1B80" }}>{location}</p>
        </div>
        <div className="d-flex gap-2 align-items-start">
          <div>
            {" "}
            <SlCalender size={24} style={{ color: " #1F46BE" }} />{" "}
          </div>
          <p style={{ color: " #1B1B1B80" }}>{date}</p>
        </div>
        <div className="d-flex gap-2 align-items-start">
          <div>
            {" "}
            <MdOutlineWatchLater size={24} style={{ color: " #1F46BE" }} />{" "}
          </div>
          <p style={{ color: " #1B1B1B80" }}>{time}</p>
        </div>
      </div>
    </>
  );
};